import { j as o } from "../../modules/index.es3.js";
import * as s from "react";
import { Slot as i } from "../../modules/index.es7.js";
import { cn as t } from "../../utils/styling.es.js";
import { cardVariants as n } from "./Card.styles.es.js";
const c = s.forwardRef(
  ({ className: a, asChild: r, ...e }, d) => {
    const m = r ? i : "div";
    return /* @__PURE__ */ o.jsx(m, { ref: d, className: t(n({ className: a })), ...e });
  }
);
c.displayName = "Card";
const f = s.forwardRef(
  ({ className: a, ...r }, e) => /* @__PURE__ */ o.jsx("div", { ref: e, className: t("space-y-2", a), ...r })
);
f.displayName = "CardHeader";
const p = s.forwardRef(
  ({ className: a, asChild: r, ...e }, d) => {
    const m = r ? i : "h3";
    return /* @__PURE__ */ o.jsx(
      m,
      {
        ref: d,
        className: t("text-lg font-medium leading-7", a),
        ...e
      }
    );
  }
);
p.displayName = "CardTitle";
const l = s.forwardRef(
  ({ className: a, ...r }, e) => /* @__PURE__ */ o.jsx(
    "div",
    {
      ref: e,
      className: t(
        "content-formatted max-w-none text-sm leading-6 text-foreground",
        a
      ),
      ...r
    }
  )
);
l.displayName = "CardDescription";
const C = s.forwardRef(
  ({ className: a, ...r }, e) => /* @__PURE__ */ o.jsx("div", { ref: e, className: t("peer", a), ...r })
);
C.displayName = "CardContent";
const x = s.forwardRef(
  ({ className: a, ...r }, e) => /* @__PURE__ */ o.jsx("div", { ref: e, className: t("space-y-4", a), ...r })
);
x.displayName = "CardFooter";
export {
  c as Card,
  C as CardContent,
  l as CardDescription,
  x as CardFooter,
  f as CardHeader,
  p as CardTitle
};
//# sourceMappingURL=Card.es.js.map
